// extracted by mini-css-extract-plugin
export default {"label":"switch_label__mAlL8","switchStyle":"switch_switchStyle__aDvwP"};